module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmV4cG9ydDwvdGl0bGU+PHBhdGggZD0iTTE3LjUsMTYuNWEuNDcuNDcsMCwwLDEtLjM1LS4xNS40OC40OCwwLDAsMSwwLS43TDIwLjc5LDEyLDE3LjE1LDguMzVhLjQ5LjQ5LDAsMCwxLC43LS43bDQsNGEuNDguNDgsMCwwLDEsMCwuN2wtNCw0QS40Ny40NywwLDAsMSwxNy41LDE2LjVaIi8+PHBhdGggZD0iTTIxLDEyLjVIOWEuNS41LDAsMCwxLDAtMUgyMWEuNS41LDAsMCwxLDAsMVoiLz48cGF0aCBkPSJNMTAuNSwyMkgzYTEsMSwwLDAsMS0xLTFWM0ExLDEsMCwwLDEsMywyaDcuNWEuNS41LDAsMCwxLDAsMUgzVjIxaDcuNWEuNS41LDAsMCwxLDAsMVoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./static/img/24px-export.svg
// module id = 808
// module chunks = 1